/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Distance_Not_PositiveInputs */

const en_us2_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The distance has to be above zero.`)
};

const pt_br2_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A distância precisa ser maior que zero.`)
};

const es_419_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La distancia tiene que ser mayor que cero.`)
};

const pt_pt2_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A distância tem de ser maior do que zero.`)
};

const fr_fr2_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La distance doit être supérieure à zéro.`)
};

const de_de2_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Strecke muss über null liegen.`)
};

const it_it2_workout_distance_not_positive = /** @type {(inputs: Workout_Distance_Not_PositiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La distanza deve essere maggiore di zero.`)
};

/**
* | output |
* | --- |
* | "The distance has to be above zero." |
*
* @param {Workout_Distance_Not_PositiveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_distance_not_positive = /** @type {((inputs?: Workout_Distance_Not_PositiveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Distance_Not_PositiveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_distance_not_positive(inputs)
	if (locale === "es-419") return es_419_workout_distance_not_positive(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_distance_not_positive(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_distance_not_positive(inputs)
	if (locale === "de-DE") return de_de2_workout_distance_not_positive(inputs)
	if (locale === "it-IT") return it_it2_workout_distance_not_positive(inputs)
	return en_us2_workout_distance_not_positive(inputs)
});
export { workout_distance_not_positive as "workout.distance_not_positive" }